<template>
  <div v-if="showAccountDetails" class="account-detail">
    <h3>ACCOUNT DETAILS</h3>
    <hg-payment-list
      class="block"
      :hg-company-id="hgCompanyId"
      :hg-folder-id="hgFolderId"
      :hg-folder-status="hgFolderStatus"
      :hg-payments="hgPayments" />

    <hg-agreement-list
      class="block"
      :hg-agreements="hgAgreements"
      :hg-folder-id="hgFolderId"
      :hg-folder-status="hgFolderStatus"
      :hg-company-id="hgCompanyId" />
  </div>
</template>


<script>
import PaymentList from './PaymentList.vue';
import AgreementList from './AgreementList.vue';

export default {
  props: {
    hgPayments: {
      required: true,
      type: Object,
    },
    hgAgreements: {
      required: true,
      type: Array,
    },
    hgFolderId: {
      required: true,
      type: String,
    },
    hgFolderStatus: {
      required: true,
      type: Object,
    },
    hgCompanyId: {
      required: true,
      type: Number,
    },
  },
  components: {
    'hg-payment-list': PaymentList,
    'hg-agreement-list': AgreementList,
  },
  computed: {
    showAccountDetails() {
      const hasAgreements = this.hgAgreements.length > 0;
      const hasPayments = this.hgPayments.payments.length > 0;
      const hasInvoiceDocuments = this.hgPayments.invoiceDocuments.length > 0;
      const hasOutstandingBalance = this.hgPayments.outstandingBalance > 0;

      return hasAgreements || hasPayments || hasInvoiceDocuments || hasOutstandingBalance;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

h3 {
  padding-top: 30px;
}

h4 {
  color: $theme-color-gray;
  font-size: 1.143rem;
  margin-bottom: 10px;
}

.account-detail {
  background-color: $theme-color-offwhite;
  padding-left: 50px;
  padding-right: 50px;
}

.account-detail .date,
.report-id {
  color:  rgba($theme-color-black, 0.6);
  font-size: 1.143rem;
}

.block {
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
  padding-bottom: 40px;
  padding-top: 40px;

  &:last-child {
    border-bottom: none;
  }
}

@media all and (max-width: 655px) {
  .account-detail {
    padding-left: 30px;
  }
}
</style>
